export { default } from '../network-coverage-v2'
